import { useTheme } from "./theme-provider";

export function ThemeSelect() {
  const theme = useTheme();
  if (!theme) return null;

  return (
    <label className="inline-flex min-w-0 items-center gap-2 text-sm text-muted-foreground">
      <span>Тема</span>
      <select
        aria-label="Тема оформления"
        className="h-9 min-w-0 rounded-md border border-input bg-card px-2 text-sm text-card-foreground outline-none focus-visible:ring-2 focus-visible:ring-ring"
        value={theme.preference}
        onChange={(event) => {
          const value = event.target.value;
          if (value === "light" || value === "dark" || value === "system") {
            theme.setPreference(value);
          }
        }}
      >
        <option value="light">Светлая</option>
        <option value="dark">Тёмная</option>
        <option value="system">Системная</option>
      </select>
    </label>
  );
}
